// extracted by mini-css-extract-plugin
export var reviews = "index-module--reviews--NoBOf";
export var textContainer = "index-module--textContainer--mnXOs";
export var title = "index-module--title--WIKI6";
export var text = "index-module--text--1k12t";
export var arrow = "index-module--arrow--1zK62";
export var carousel = "index-module--carousel--1AOGf";
export var bold = "index-module--bold--3XlhZ";